import React, { useState } from 'react'
import PropTypes from 'prop-types'
import Table from './table'
import FormModal from './form-modal'
import FlashAlert from '../../components/flash-alert'
import { ajaxDelete } from '../../ajax'

function Partners({partners, onCreate, onUpdate, onDelete}) {
  const [showForm, setShowForm] = useState()
  const [alert, setAlert] = useState()
  const [query, setQuery] = useState('')
  const [loading, setLoading] = useState(false)

  const onCreated = (data) => {
    onCreate(data)
    setShowForm()
    setAlert({ text: 'Organizer has been added', type: 'success' })
  }

  const onUpdated = (data) => {
    onUpdate(data)
    setShowForm()
    setAlert({ text: 'Organizer has been updated', type: 'success' })
  }

  const filteredPartners = () => {
    if (!query.length) return partners

    return partners.filter(p => `${p.name} ${p.email}`.toLowerCase().includes(query.toLowerCase()))
  }

  const onDeleteClicked = async (partner) => {
    if (window.confirm('Are you sure you want to delete the organizer?')) {
      deletePartner(partner)
    }
  }

  const deletePartner = async (partner) => {
    setLoading(true)
    const url = `/admins/partners/${partner.id}`
    const response = await ajaxDelete(url)
    const json = await response.json()
    setLoading(false)
    if (json.alert)
      setAlert(json.alert)
    else {
      setAlert({ text: 'Organizer has been deleted', type: 'success' })
      onDelete(partner)
    }
  }

  return <div className={loading ? ' isLoading' : ''}>
    { alert && <FlashAlert text={alert.text} type={alert.type} onHide={() => setAlert(null)} />}
    { loading && <div className='animated-spinner'></div> }
    <div className='title'>Organizers</div>
    <div className='header'>
      <input className='form-control' placeholder='Search' value={query} onChange={e => setQuery(e.target.value)} />
      <button className='btn btn-success add-partner' onClick={() => setShowForm({})}>Create New</button>
    </div>
    <Table
      partners={filteredPartners()}
      onEdit={partner => setShowForm(partner)}
      onDelete={onDeleteClicked}
    />
    { showForm && 
      <FormModal
        data={showForm}
        onClose={() => setShowForm()}
        onCreate={onCreated}
        onUpdate={onUpdated}
      />
    }
  </div>
}

Partners.propTypes = {
  partners: PropTypes.array.isRequired,
  onCreate: PropTypes.func.isRequired,
  onUpdate: PropTypes.func.isRequired,
  onDelete: PropTypes.func.isRequired
}

export default Partners
